import {DatePicker} from '@/components/ui/date-picker.tsx';
import {Label} from '@/components/ui/label.tsx';

type DayPickerFieldProps = {
	id: string;
	label: string;
	value: string;
	onChange: (value: string) => void;
	min?: string;
	max?: string;
};

export function DayPickerField({
	id,
	label,
	value,
	onChange,
	min,
	max,
}: DayPickerFieldProps) {
	return (
		<div className="flex min-w-[200px] flex-1 flex-col gap-1.5">
			<Label htmlFor={id}>{label}</Label>
			<DatePicker id={id} value={value} onChange={onChange} min={min} max={max}/>
		</div>
	);
}
